// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DownloadOptions = { [key: string]: any };

export class DownloadManager {
    public static async download(url: string, options: DownloadOptions = {}): Promise<string> {
        return new Promise<string>(function startVideoLoading(resolve, reject) {
            const req = new XMLHttpRequest();
            const videoUrl = url;
            req.open('GET', videoUrl, true);
            req.responseType = 'blob';

            req.onload = function handleObjectLoading() {
                if (this.status === 200) {
                    try {
                        const blob = this.response;
                        const objectUrl: string = URL.createObjectURL(blob);
                        resolve(objectUrl);
                    } catch (error) {
                        reject();
                        window.Sentry.captureException(error);
                    }
                } else {
                    throw new Error(`Loaded video with non-200 response: ${this.status}`);
                }
            };

            req.onerror = function onVideoLoadError() {
                reject(new Error('Loading failed'));
            };

            req.onprogress = function onLoadProgress(event) {
                options?.onProgress(Math.ceil(event.loaded / event.total * 100));
            };

            req.send();
        });
    }
}
